import { deleteRequest } from '@/core';
import { savedTripSearches } from '@/requests';

export default async function updateSavedTripSearchesRequest(id) {
	let url = savedTripSearches.getByIdPath(id);
	let response = await deleteRequest(url);
	return response;
}